export const TipsDistributionRoutes = {
    "/tips-distribution-hybrid?date&paysheetTypeId&payPeriodId&source": {
        "name": "appLayout.schedule.tips-distribution-hybrid",
        "loginRequired": true,
        "type": "frontend",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Tips Distribution"
            }
        ],
        "params": {
            date: {
                dynamic: true,
            },
            payPeriodId: {
                dynamic: true,
            },
            paysheetTypeId: {
                dynamic: true,
            },
            source: {
                dynamic: true,
            },
        },
        "route_styles": {
            "framework": "bootstrap_v4",
            styles: [
                "tips-distribution",
            ],
        },
        "views": {
            'body': {
                component: 'tipsDistributionStepsContainer'
            },
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./tips-distribution.module.js");
                },
            },
        ],
        'onEnter': ['$state', '$stateParams', 'hUser', 'brandServices', 'userPermissions',
            async ($state, $stateParams, hUser, brandServices, userPermissions) => {

            const redirectToMainSchedule = () => {
                $state.go('appLayout.schedule.main');
            };

            // Validate state params
            if (
                (
                    !$stateParams.date
                ) ||
                (
                    !$stateParams.paysheetTypeId !== !$stateParams.payPeriodId
                )
            ) {
                redirectToMainSchedule();
            }

            const activeBrandId = hUser.getActiveBrandIdWithAccess();

            const [
                isClockTimeAppEnabled,
                policyParser
            ] = await Promise.all([
                brandServices.check(brandServices.SERVICES.HARRI_CLOCK, activeBrandId),
                userPermissions.getBrandPolicy(activeBrandId)
            ]);

            // Validate clock time accessibility
            if (!isClockTimeAppEnabled) {
                redirectToMainSchedule();
            }

            // Validate paysheet requirements
            if (
                $stateParams.paysheetTypeId &&
                $stateParams.payPeriodId
            ) {
                const isPaySheetAdmin = policyParser.has(userPermissions.PERMISSIONS.ADVANCED_PDS_ACCESS);

                if (!isPaySheetAdmin) {
                    redirectToMainSchedule();
                }
            }
            // Validate timesheet requirements
            else {
                const isAllowedAccessTimeSheet = policyParser.hasAny(userPermissions.MANAGE_TIME_CARDS);

                if (!isAllowedAccessTimeSheet) {
                    redirectToMainSchedule();
                }
            }
        }],
    },
};
